import { BooleanEnum } from '../../..';

export class GetUsersByIdsQueryDto {
  withSensitiveData?: BooleanEnum;
  withRelations?: BooleanEnum;
}
